import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Home, Sparkles, ShoppingBag, Wallet, User, ChevronUp, ChevronDown } from "lucide-react";
import { useAuth } from "@/lib/auth";

const items = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/pluse", label: "Pluse", icon: Sparkles },
  { to: "/store", label: "Store", icon: ShoppingBag },
  { to: "/wallet", label: "Wallet", icon: Wallet },
  { to: "/profile", label: "You", icon: User },
];

export default function MobileNav() {
  const { user } = useAuth();
  const location = useLocation();
  const isCommunities = /^\/Communities(?:\/|$)/i.test(location.pathname);
  const [dockVisible, setDockVisible] = useState(false);

  if (isCommunities) {
    return (
      <div className="lg:hidden fixed bottom-16 left-3 z-[100] flex flex-col items-start gap-2">
        {dockVisible && (
          <nav data-testid="mobile-bottom-nav" className="rounded-2xl overflow-hidden backdrop-blur-xl bg-black/90 border border-white/15 shadow-2xl pb-[env(safe-area-inset-bottom)]">
            <div className="grid grid-cols-5">
              {items.map(({ to, label, icon: Icon, end }) => (
                <NavLink
                  key={to}
                  to={to === "/profile" && !user ? "/get-started" : to}
                  end={end}
                  data-testid={`bottomnav-${label.toLowerCase()}`}
                  className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 px-3 py-2 text-[10px] uppercase tracking-wider ${isActive ? "text-[#FFBF00]" : "text-white/60"}`}
                >
                  <Icon size={20} />
                  {label}
                </NavLink>
              ))}
            </div>
          </nav>
        )}
        <button
          type="button"
          aria-label={dockVisible ? "Hide navigation dock" : "Show navigation dock"}
          onClick={() => setDockVisible(v => !v)}
          className="w-10 h-10 rounded-full border border-white/20 bg-black/85 text-white shadow-xl backdrop-blur-xl flex items-center justify-center"
        >
          {dockVisible ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
        </button>
      </div>
    );
  }

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 backdrop-blur-xl bg-black/80 border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to === "/profile" && !user ? "/get-started" : to}
            end={end}
            data-testid={`bottomnav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] uppercase tracking-wider ${
                isActive ? "text-[#FFBF00]" : "text-white/60"
              }`
            }
          >
            <Icon size={20} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
